import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-chat-error-icon',
  templateUrl: './communication-chat-error.component.html'
})
export class CommunicationChatErrorComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
